import { ColorList } from "./components/colorList/colorList";
import { Base } from "./families.base";

export const Families = Object.assign(Base, {
    ColorList
});
